import { useContext, useState } from 'react'

import { Button, Grid, Tooltip } from '@material-ui/core'
import PrintIcon from '@material-ui/icons/Print'
import { EditContext } from 'Components/Hooks/ContextEdit'
import { FormContext } from 'Components/Hooks/ContextForm'
import SetState from 'Components/Hooks/SetState'
import Loader from 'Components/UI/Atoms/Loader'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import useStyles from '../../styles'

import Table from './Table'

const ContentAppBarTabs = (props) => {
  const createDismissableSnackbar = useCustomSnackbar()
  const [edit] = useContext(EditContext)
  const classes = useStyles()
  const { formEdit } = useContext(FormContext)
  const [loading, setLoading] = useState(false)
  const { wafers, habilitar, handleOpenRev, revisionConfirm } = props

  async function apiFront() {
    await interfaces.vehicleInterface
      .front04D(formEdit.vehicle.id, { dominio: withDominio })
      .then(
        (res) => {
          printPDF(res, 500, 800).print()
        },
        setClose(),
        setLoading(true)
      )
      .catch((_error) => {
        createDismissableSnackbar('Algo salió mal, puede faltar algún dato!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const { state, setClose, setOpen } = SetState()

  async function handleOpen() {
    setLoading(false)
    setOpen()
  }

  const [withDominio, setWithDominio] = useState('SI')

  const handleChange = (value) => {
    setWithDominio(value)
  }

  async function apiBack() {
    await interfaces.vehicleInterface
      .back04D(formEdit.vehicle.id)
      .then((res) => {
        printPDF(res, 500, 800).print()
      }, setLoading(true))
      .catch((_error) => {
        createDismissableSnackbar('Algo salió mal, puede faltar algún dato!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const front = () => {
    if (
      !formEdit.vehicle.marca ||
      !formEdit.vehicle.modelo ||
      !formEdit.vehicle.modelo_titulo ||
      !formEdit.vehicle.vehiculo_info.motor_marca ||
      !formEdit.vehicle.vehiculo_info.motor_nro ||
      !formEdit.vehicle.vehiculo_info.chasis_marca ||
      !formEdit.vehicle.vehiculo_info.chasis_nro ||
      !formEdit.vehicle.vehiculo_info.color ||
      !formEdit.vehicle.vehiculo_info.combustible
    ) {
      return 'Falta algún dato para poder presionar este botón'
    } else {
      return 'Debe guardar los cambios antes de presionar este botón'
    }
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item sm={12}>
          <Table wafers={wafers} />
        </Grid>
        <div className={classes.buttonsWafers}>
          <Grid item>
            <Button
              disabled={edit ? false : true}
              onClick={handleOpenRev}
              // onClick={revision}
              variant="contained"
              color="primary"
            >
              Revisión
            </Button>
          </Grid>

          <Grid item>
            <Tooltip title={front()} placement="top">
              <Button
                disabled={edit && habilitar === 1 ? false : revisionConfirm ? false : true}
                onClick={handleOpen}
                variant="contained"
                endIcon={<PrintIcon />}
                style={{
                  marginRight: '15px',
                  marginLeft: '15px',
                }}
              >
                04-D FRENTE
              </Button>
            </Tooltip>
          </Grid>

          {state.suspense && (
            <DialogComponent
              open={state.open}
              title="¿Agregar dominio?"
              handleclose={setClose}
              widthLarge="400px"
              maxHeight
              disableBackdropClick
              disableEscapeKeyDown
              actions={
                <CancelConfirmButtons
                  onClickCancel={() => setClose()}
                  onClickSubmit={() => apiFront()}
                />
              }
              children={
                <InputsWithoutValidate
                  fields={[
                    {
                      class: 'autocomplete',
                      name: 'dominio',
                      options: [
                        {
                          label: 'SI',
                        },
                        {
                          label: 'NO',
                        },
                      ],
                      optionLabel: `options["label"]`,
                      optionValue: 'label',
                      value: withDominio,
                      sm: 12,
                      xs: 12,
                      onChange: (e) => handleChange(e.label),
                    },
                  ]}
                  spacing={2}
                />
              }
            />
          )}

          <Grid item>
            <Tooltip title="Debe guardar los cambios antes de presionar este botón" placement="top">
              <Button
                disabled={edit && habilitar === 1 ? false : revisionConfirm ? false : true}
                onClick={apiBack}
                variant="contained"
                endIcon={<PrintIcon />}
              >
                04-D Dorso
              </Button>
            </Tooltip>
          </Grid>
        </div>
      </Grid>
      {loading ? <Loader /> : null}
    </div>
  )
}

export default ContentAppBarTabs
